import React from "react";

const Done = () => {
  return <div>Done;</div>;
};

export default Done;
